// 汇率只在展示时四舍五入到两位，保留原始值用于计算与提交。
export default function formatExchangeRate(value) {
  const text = String(value ?? '').trim();
  const match = /^([+-]?)(\d+)(?:\.(\d*))?$/.exec(text);
  if (!match) return '—';
  const fraction = (match[3] || '').padEnd(3, '0');
  const digits = `${match[2]}${fraction.slice(0, 2)}`.replace(/^0+(?=\d)/, '').split('');
  if (fraction[2] >= '5') {
    let carry = 1;
    for (let index = digits.length - 1; index >= 0 && carry; index -= 1) {
      const incremented = Number(digits[index]) + carry;
      digits[index] = String(incremented % 10);
      carry = incremented >= 10 ? 1 : 0;
    }
    if (carry) digits.unshift('1');
  }
  const cents = digits.join('').padStart(3, '0');
  const sign = match[1] === '-' && /[1-9]/.test(cents) ? '-' : '';
  return `${sign}${cents.slice(0, -2)}.${cents.slice(-2)}`;
}
